import { Col, Input, Row, Select } from 'antd';
import React from 'react';
import SelectSearch from '../../../../component/input/SelectSearch';

const AccessSettings = ({ form, listRole, listDataGroup, _onChangeSelect, style }) => {

  return (
    <>
      <div className='font-roboto font-semibold text-[20px] mt-5'>
        GroLog Access Setting
      </div>

      <Row className='mt-3'>
        <Col span={10}>
          <div>
            <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                Grolog Account
              </p>
              <Input 
                style={{ width: '100%' }} 
                size='large'
                disabled
                value={form?.grolog_account}
              />
          </div>
          <div>
            <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D] mt-4'>
                Role
              </p>
              {/* <SelectSearch onSelect={(value) => _onChangeSelect(value, 'role_id')} style={style} from={'USER'} data={listRole} defaultValue={listRole ? listRole[0] : ''} /> */}
              <Select
                    className="w-[500px]"
                    dropdownStyle={{
                      backgroundColor: "white",
                    }}
                    size="large"
                    value={form.role_id ? form.role_id : "-"}
                    onChange={(value) =>
                      _onChangeSelect(value, 'role_id')
                    }
                    placeholder="Select Title"
                    // dropdownRender={(menu) =>
                    //   dropdownCustom(
                    //     menu,
                    //     (value) => onChangeTitle(value),
                    //     searchValue
                    //   )
                    // }
                  >
                    {listRole}
                    {/* {!loading ? title : [...title, LoadingOption()]} */}
                  </Select>
          </div>
          <div>
            <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D] mt-4'>
                Data Group
              </p>
              <Select
                    className="w-[500px]"
                    dropdownStyle={{
                      backgroundColor: "white",
                    }}
                    size="large"
                    value={form.data_group_id ? form.data_group_id : "-"}
                    onChange={(value) =>
                      _onChangeSelect(value, 'data_group_id')
                    }
                    placeholder="Select Title"
                    // dropdownRender={(menu) =>
                    //   dropdownCustom(
                    //     menu,
                    //     (value) => onChangeTitle(value),
                    //     searchValue
                    //   )
                    // }
                  >
                    {listDataGroup}
                    {/* {!loading ? title : [...title, LoadingOption()]} */}
                  </Select>
              {/* <SelectSearch onSelect={(value) => _onChangeSelect(value, 'data_group_id')} style={style} from={'USER'} data={listDataGroup} defaultValue={listDataGroup ? listDataGroup[0] : ''} /> */}
          </div>
        </Col>
      </Row>
    </>
  );
}

export default AccessSettings;